import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import themes from '../../../theme-main/Theme';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Chip,
    ClickAwayListener,
    Divider,
    Grid,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Stack,
    Switch,
    Typography,
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import MainCard from '../../../ui-component/cards/MainCard';
import Transitions from '../../../ui-component/extended/Transitions';
import LockResetIcon from '@mui/icons-material/LockReset';

import { setMode } from '../../../../redux/create-actions/CustomizationAction';
import {
    IconLogout,
    IconSettings,
    IconUser
} from '@tabler/icons';
import { showAlert } from '../../../../redux/create-actions/AlertAction';
import Color from '../../../Color';
import { graphCustomerLogout } from '../../../../services/Authenticate';
import Storage from '../../../../services/Storage';

// ==============================|| PROFILE MENU ||============================== //

const fontWeight = { fontWeight: 400 };
const scrollBar = { height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' };
const boxStyle = { p: 2, pt: 0 };

const ProfileSection = () => {
    const customization = useSelector((state) => state.customization);
    const theme = themes(customization);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    var time = new Date().getHours();
    const [sdm, setSdm] = useState(customization.mode === 'dark');
    const [notification, setNotification] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const [profile,] = useState(JSON.parse(Storage.getLocalProfile()));
    /**
     * anchorRef is used on different components and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);
    const handleLogout = async () => {
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            message: '',
        };

        const response = graphCustomerLogout();
        response.then(result => {
            alert = { ...alert, Title: 'Success', severity: 'success', message: 'Logout Successfully!' }
            dispatch(showAlert(alert));
            Storage.removeAccessToken();
            Storage.removeRefreshToken();
            Storage.removeLocalProfile();
            window.location = '/';
        }).catch(error => {
            const err = JSON.parse(JSON.stringify(error));
            console.log(err);
        })
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleListItemClick = (event, index, route = '') => {
        setSelectedIndex(index);
        handleClose(event);

        if (route && route !== '') {
            navigate(route);
        }
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <>
            <Chip
                sx={{
                    height: '48px',
                    alignItems: 'center',
                    borderRadius: '27px',
                    transition: 'all .2s ease-in-out',
                    borderColor: theme.palette.success.light,
                    backgroundColor: theme.palette.success.light,
                    '&[aria-controls="menu-list-grow"], &:hover': {
                        borderColor: theme.palette.success[200],
                        background: `${theme.palette.success[200]} !important`,
                        color: theme.palette.success.light,
                        '& svg': {
                            stroke: () => sdm === false ? theme.palette.success.light : theme.palette.success.dark
                        }
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                icon={
                    <Avatar
                        src={'./images/user/user-profile.svg'}
                        sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px 0 8px 8px !important',
                            cursor: 'pointer',
                            background: Color.Button,
                        }}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                    />
                }
                label={<IconSettings stroke={1.5} size="1.5rem" color={sdm === false ? theme.palette.success.main : theme.palette.success.dark} />}
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="success"
            />
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box sx={{ p: 2 }}>
                                        <Stack>
                                            <Stack direction="row" spacing={0.5} alignItems="center">
                                                <Typography variant="h4">
                                                    Good
                                                    {
                                                        (time >= 5 && time < 11) ? " Morning," :
                                                            (time >= 11 && time < 13) ? " Noon," :
                                                                (time >= 13 && time < 18) ? " Afternoon," :
                                                                    (time >= 18 && time <= 23) ? " Evening," :
                                                                        (time >= 0 && time < 4) ? " Night," :
                                                                            " Dawn,"
                                                    }
                                                </Typography>
                                                {profile !== null ? (
                                                    <Typography component="span" variant="h4" sx={fontWeight}>
                                                        {profile.customerName}
                                                    </Typography>
                                                ) : (
                                                    <Typography component="span" variant="h4" sx={fontWeight}>
                                                    </Typography>
                                                )
                                                }
                                            </Stack>
                                        </Stack>
                                    </Box>
                                    <PerfectScrollbar style={scrollBar}>
                                        <Box sx={boxStyle}>
                                            {/* <UpgradeCard /> */}
                                            <Divider />
                                            <Card
                                                sx={{
                                                    bgcolor: theme.palette.success.light,
                                                    my: 2
                                                }}
                                            >
                                                <CardContent>
                                                    <Grid container spacing={3} direction="column">
                                                        <Grid item>
                                                            <Grid item container alignItems="center" justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="body1">Dark Mode</Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Switch
                                                                        color="primary"
                                                                        checked={sdm}
                                                                        onChange={(e) => {
                                                                            setSdm(e.target.checked);
                                                                            dispatch(setMode());
                                                                        }}
                                                                        name="sdm"
                                                                        size="small"
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item>
                                                            <Grid item container alignItems="center" justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="body1">Allow Notifications</Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Switch
                                                                        color="primary"
                                                                        checked={notification}
                                                                        onChange={(e) => setNotification(e.target.checked)}
                                                                        name="sdm"
                                                                        size="small"
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                            <Divider />
                                            <List
                                                component="nav"
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: 350,
                                                    minWidth: 300,
                                                    backgroundColor: theme.palette.background.paper,
                                                    borderRadius: '10px',
                                                    [theme.breakpoints.down('md')]: {
                                                        minWidth: '100%'
                                                    },
                                                    '& .MuiListItemButton-root': {
                                                        mt: 0.5
                                                    }
                                                }}
                                            >

                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 0}
                                                    onClick={(event) => handleListItemClick(event, 0, '/user/change-pass')}
                                                >
                                                    <ListItemIcon>
                                                        <LockResetIcon size="small" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2">Change Password</Typography>} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 1}
                                                    onClick={(event) => handleListItemClick(event, 1, '/user/profile')}
                                                >
                                                    <ListItemIcon>
                                                        <IconUser stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Grid container spacing={1} justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="body2">Profile</Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Chip
                                                                        label="02"
                                                                        size="small"
                                                                        sx={{
                                                                            bgcolor: theme.palette.warning.dark,
                                                                            color: theme.palette.background.default
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 4}
                                                    onClick={handleLogout}
                                                >
                                                    <ListItemIcon>
                                                        <IconLogout stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
                                                </ListItemButton>
                                            </List>
                                        </Box>
                                    </PerfectScrollbar>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>
        </>
    );
};

export default ProfileSection;
